export default __webpack_public_path__ + "images/6bfc3dacfe10d5efde67fb1dc554547e-new_york_desktop.webp";